module.exports = __webpack_public_path__ + "static/img/frame.04989cd5.png";